import React, { Component } from 'react'

export default class Logo extends Component {
	constructor(context) {
		super(context);
	}

	render() {
		return (<div></div>)
	}
}